module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_15.81998dad.jpeg";